import { useCallback, useEffect, useState, createRef } from 'react'
import {
  ContentWidth,
  TextWidthExtended,
  TextWidth,
} from '@ta-interaktiv/react-disco-grid'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import GridItem from 'components/GridItem'

const Grid = ({
  tenant,
  colorMode,
  selectedCategory,
}: {
  tenant?: object
  colorMode?: string
  selectedCategory?: string
}) => {
  const [data, setData] = useState<any[]>([])
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffectOnce(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/nationalrats-bilanz-zuerich/personen.json'
    )
      .then((response) => response.json())
      .then((rawData: any) => {
        setData(rawData)
      })

    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  const filteredCategory = data.filter(
    (item: any) =>
      item.Kategorie.toUpperCase() === selectedCategory?.toUpperCase()
  )

  return (
    <GridWrapper className={isMobile ? 'mobile' : 'desktop'}>
      <MasonryWrapper>
        <ResponsiveMasonry columnsCountBreakPoints={{ 0: 1, 1024: 2 }}>
          <Masonry
            style={{
              gap: isMobile ? '3rem' : '5.4rem',
            }}
          >
            {
              //map through data and create a GridItem for each item
              filteredCategory &&
                filteredCategory.map(function (item: any, index: number) {
                  return (
                    <>
                      <GridItem
                        // title={item.Titel}
                        // titleMobile={item.TitelMobile}
                        image={item.Bild}
                        // caption={item.Bildquelle}
                        name={item.Name}
                        party={item.Partei}
                        text={item.Text}
                        key={index}
                        colorMode={colorMode}
                        className={index % 2 ? 'even' : 'odd'}
                      ></GridItem>
                    </>
                  )
                })
            }
          </Masonry>
        </ResponsiveMasonry>
      </MasonryWrapper>
    </GridWrapper>
  )
}

const GridWrapper = styled.div`
  max-width: 1072px;
  margin: 4rem auto;
  @media only screen and (min-width: 600px) and (max-width: 1024px) {
    max-width: 582px;
  }
`

const MasonryWrapper = styled.div`
  @media only screen and (min-width: 1025px) and (max-width: 1680px) {
    padding: 0 6rem;
  }
`

export default Grid
